export type RoleTeam = "village" | "werewolf" | "neutral";

export type RoleId =
  | "doppelganger"
  | "werewolf"
  | "minion"
  | "mason"
  | "seer"
  | "robber"
  | "troublemaker"
  | "drunk"
  | "insomniac"
  | "villager"
  | "hunter"
  | "tanner";

export interface RoleDefinition {
  readonly id: RoleId;
  readonly nameKo: string;
  readonly team: RoleTeam;
  readonly maxCopies: number;
  readonly wakesAtNight: boolean;
  readonly nightOrder?: number;
}

export interface RoleCard {
  readonly id: string;
  readonly roleId: RoleId;
}

export const ROLE_DEFINITIONS: Readonly<Record<RoleId, RoleDefinition>> = {
  doppelganger: {
    id: "doppelganger",
    nameKo: "도플갱어",
    team: "neutral",
    maxCopies: 1,
    wakesAtNight: true,
    nightOrder: 1,
  },
  werewolf: {
    id: "werewolf",
    nameKo: "늑대인간",
    team: "werewolf",
    maxCopies: 2,
    wakesAtNight: true,
    nightOrder: 2,
  },
  minion: {
    id: "minion",
    nameKo: "미니언",
    team: "werewolf",
    maxCopies: 1,
    wakesAtNight: true,
    nightOrder: 3,
  },
  mason: {
    id: "mason",
    nameKo: "메이슨",
    team: "village",
    maxCopies: 2,
    wakesAtNight: true,
    nightOrder: 4,
  },
  seer: {
    id: "seer",
    nameKo: "예언자",
    team: "village",
    maxCopies: 1,
    wakesAtNight: true,
    nightOrder: 5,
  },
  robber: {
    id: "robber",
    nameKo: "강도",
    team: "village",
    maxCopies: 1,
    wakesAtNight: true,
    nightOrder: 6,
  },
  troublemaker: {
    id: "troublemaker",
    nameKo: "트러블메이커",
    team: "village",
    maxCopies: 1,
    wakesAtNight: true,
    nightOrder: 7,
  },
  drunk: {
    id: "drunk",
    nameKo: "주정뱅이",
    team: "village",
    maxCopies: 1,
    wakesAtNight: true,
    nightOrder: 8,
  },
  insomniac: {
    id: "insomniac",
    nameKo: "불면증 환자",
    team: "village",
    maxCopies: 1,
    wakesAtNight: true,
    nightOrder: 9,
  },
  villager: {
    id: "villager",
    nameKo: "마을 주민",
    team: "village",
    maxCopies: 3,
    wakesAtNight: false,
  },
  hunter: {
    id: "hunter",
    nameKo: "사냥꾼",
    team: "village",
    maxCopies: 1,
    wakesAtNight: false,
  },
  tanner: {
    id: "tanner",
    nameKo: "태너",
    team: "neutral",
    maxCopies: 1,
    wakesAtNight: false,
  },
};
